// Almacenamiento local de socias (solo Frontend)
// Persiste en localStorage y ofrece utilidades de CRUD simples.

const STORAGE_KEY = 'fepast_socias_v1';

function readAll() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return [];
    const arr = JSON.parse(raw);
    return Array.isArray(arr) ? arr : [];
  } catch {
    return [];
  }
}

function writeAll(list) {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(list || []));
}

function seedIfEmpty() {
  const current = readAll();
  if (current.length > 0) return current;
  const seeds = [
    {
      id: 'SOCIA-0001',
      caracteristicasPresentes: [1, 2, 4],
      datosPersonales: {
        nombres: 'María José',
        apellidos: 'González López',
        cedula: '1234567890',
        fechaNacimiento: '1990-05-15',
        edad: 33,
        estadoCivil: 'Soltera',
        nacionalidad: 'Ecuatoriana',
        profesion: 'Diseñadora',
        sexo: 'Femenino',
        tipoSocio: 'TS001', // TS (tipo de socia) si existe
        foto: ''
      },
      datosUbicacion: {
        pais: 'Ecuador',
        ciudadDistrito: 'Quito',
        sectorBarrio: 'La Carolina',
        provinciaRegion: 'Pichincha',
        correoElectronico: 'maria@ejemplo.com',
        telefono1: '0999-999-999',
        telefono2: '022-555-555',
        direccion: 'Av. Principal 123'
      },
      datosMedicos: {
        padeceSindrome: 'Turner',
        tipoSindrome: 'Mosaicismo',
        estado: 'Activo',
        ultimaConsulta: '2025-09-01',
        fechaInscripcion: '2020-01-10',
        cariotipo: '45,X/46,XX',
        discapacidad: 'Auditiva',
        porcentaje: '40%',
        tipoDiscapacidad: 'Parcial',
        grado: 'Moderado',
        iess: 'Sí',
        edadDeteccion: '5',
        talla: '1.55m',
        hormonaCrecimiento: 'No',
        ministerioSalud: 'Sí',
        mentor: 'Dra. Pérez'
      },
      requisitosEntregados: []
    },
    {
      id: 'SOCIA-0002',
      caracteristicasPresentes: [2, 3],
      datosPersonales: {
        nombres: 'Ana Lucía',
        apellidos: 'Martínez Ruiz',
        cedula: '0987654321',
        fechaNacimiento: '1985-11-23',
        edad: 39,
        estadoCivil: 'Casada',
        nacionalidad: 'Peruana',
        profesion: 'Ingeniera',
        sexo: 'Femenino',
        tipoSocio: 'TS002',
        foto: ''
      },
      datosUbicacion: {
        pais: 'Perú',
        ciudadDistrito: 'Lima',
        sectorBarrio: 'Miraflores',
        provinciaRegion: 'Lima',
        correoElectronico: 'ana@ejemplo.com',
        telefono1: '0998-888-888',
        telefono2: '',
        direccion: 'Calle Falsa 123'
      },
      datosMedicos: {
        padeceSindrome: 'No',
        tipoSindrome: 'N/A',
        estado: 'Inactivo',
        ultimaConsulta: '',
        fechaInscripcion: '2019-06-15',
        cariotipo: '',
        discapacidad: 'Visual',
        porcentaje: '20%',
        tipoDiscapacidad: 'Leve',
        grado: 'Leve',
        iess: 'No',
        edadDeteccion: '',
        talla: '1.62m',
        hormonaCrecimiento: 'No',
        ministerioSalud: 'No',
        mentor: ''
      },
      requisitosEntregados: []
    },
    {
      id: 'SOCIA-0003',
      caracteristicasPresentes: [1, 5, 6],
      datosPersonales: {
        nombres: 'Carla',
        apellidos: 'Sánchez',
        cedula: '1122334455',
        fechaNacimiento: '2000-02-02',
        edad: 25,
        estadoCivil: 'Soltera',
        nacionalidad: 'Colombiana',
        profesion: 'Estudiante',
        sexo: 'Femenino',
        tipoSocio: 'TS003',
        foto: ''
      },
      datosUbicacion: {
        pais: 'Colombia',
        ciudadDistrito: 'Medellín',
        sectorBarrio: 'El Poblado',
        provinciaRegion: 'Antioquia',
        correoElectronico: 'carla@ejemplo.com',
        telefono1: '0997-777-777',
        telefono2: '034-123-4567',
        direccion: 'Cra 45 #10-20'
      },
      datosMedicos: {
        padeceSindrome: 'Sí',
        tipoSindrome: 'Clásico',
        estado: 'Activo',
        ultimaConsulta: '2025-08-15',
        fechaInscripcion: '2021-03-20',
        cariotipo: '45,X',
        discapacidad: 'Motora',
        porcentaje: '60%',
        tipoDiscapacidad: 'Total',
        grado: 'Severo',
        iess: 'Sí',
        edadDeteccion: '2',
        talla: '1.48m',
        hormonaCrecimiento: 'Sí',
        ministerioSalud: 'Sí',
        mentor: 'Dr. Gómez'
      },
      requisitosEntregados: []
    }
  ];
  writeAll(seeds);
  return seeds;
}

function nextCode(currentList) {
  const nums = (currentList || []).map(s => parseInt(String(s.id).split('-')[1] || '0', 10)).filter(n => !isNaN(n));
  const next = (nums.length ? Math.max(...nums) : 0) + 1;
  return 'SOCIA-' + String(next).padStart(4, '0');
}

export const sociasStore = {
  getAll() {
    const list = readAll();
    return list.length ? list : seedIfEmpty();
  },
  ensureSeed() {
    return seedIfEmpty();
  },
  add(formData) {
    const all = this.getAll();
    const id = nextCode(all);
    const newSocia = {
      id,
      caracteristicasPresentes: [],
      requisitosEntregados: [],
      datosPersonales: {
        nombres: formData.nombres || formData.firstName || '',
        apellidos: formData.apellidos || formData.lastName || '',
        cedula: formData.cedula || '',
        fechaNacimiento: formData.fechaNacimiento || '',
        edad: formData.edad ? Number(formData.edad) : '',
        estadoCivil: formData.estadoCivil || '',
        nacionalidad: formData.nacionalidad || '',
        profesion: formData.profesion || '',
        sexo: formData.sexo || 'Femenino',
        tipoSocio: formData.tipoSocio || '',
        foto: ''
      },
      datosUbicacion: {
        pais: formData.pais || '',
        ciudadDistrito: formData.ciudadDistrito || '',
        sectorBarrio: formData.sectorBarrio || '',
        provinciaRegion: formData.provinciaRegion || '',
        correoElectronico: formData.correoElectronico || formData.email || '',
        telefono1: formData.telefono1 || formData.phone || '',
        telefono2: formData.telefono2 || '',
        direccion: formData.direccion || ''
      },
      datosMedicos: {
        padeceSindrome: formData.padeceSindrome || '',
        tipoSindrome: formData.tipoSindrome || '',
        estado: formData.estado || 'Activo',
        ultimaConsulta: '',
        fechaInscripcion: formData.fechaInscripcion || '',
        cariotipo: formData.cariotipo || '',
        discapacidad: formData.discapacidad || '',
        porcentaje: formData.porcentaje || '',
        tipoDiscapacidad: formData.tipoDiscapacidad || '',
        grado: formData.grado || '',
        iess: formData.iess || '',
        edadDeteccion: formData.edadDeteccion || '',
        talla: formData.talla || '',
        hormonaCrecimiento: formData.hormonaCrecimiento || '',
        ministerioSalud: formData.ministerioSalud || '',
        mentor: formData.mentor || 'No asignado'
      }
    };
    const updated = [...all, newSocia];
    writeAll(updated);
    return newSocia;
  },
  update(id, patch) {
    const all = this.getAll();
    const updated = all.map(s => s.id === id ? { ...s, ...patch } : s);
    writeAll(updated);
    return updated.find(s => s.id === id) || null;
  },
  updateNested(id, updater) {
    const all = this.getAll();
    const idx = all.findIndex(s => s.id === id);
    if (idx === -1) return null;
    const next = updater({ ...all[idx] });
    all[idx] = next;
    writeAll(all);
    return next;
  },
  setEstado(id, estado) {
    return this.updateNested(id, s => {
      s.datosMedicos = { ...(s.datosMedicos || {}), estado };
      return s;
    });
  }
};

export default sociasStore;
